import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  color: ${ (props) => props.theme.colors.barGraphForeground };
  white-space: nowrap;

  .bar-graph-wrapper {
    position: relative;
    height: 20px;
    width: 100%;
    max-width: 200px;
    margin-right: 5px;
    margin-bottom: 1px;
  }

  .bar-graph-average {
    position: absolute;
    width: 2px;
    top: 0;
    height: 100%;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background-color: ${ (props) => props.theme.colors.weiss };
    left: ${ (props) => props.averagePercent }%;
  }
`

export const graphBackground = styled.div`
  position: relative;
  border-radius: 2px;
  height: 20px;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background: ${ (props) => props.theme.colors.barGraphBackground };

  @media print {
    border: 1px solid ${ (props) => props.theme.colors.barGraphBackground };
  }
`

export const graph = styled.div`
  position: relative;
  margin-top: -20px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  width: ${ (props) => props.percent }%;
  height: 20px;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background: ${ (props) => props.theme.colors.barGraphForeground };

  @media print {
    border: 1px solid ${ (props) => props.theme.colors.barGraphForeground };
  }
`

export const Value = styled.span`
  font-size: 14px;
  color: ${ (props) => props.theme.colors.barGraphPercentValue };
  font-weight: 400;
  min-width: 35px;
`
